import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { omitBy, snakeCase } from 'lodash'

import { Label } from 'components/label/Label'
import { Text } from 'components/text/Text'

import styles from './Textarea.module.scss'

export const Textarea = ({
  className,
  dataTestId,
  isDisabled = false,
  maxLength,
  onChange,
  placeholder = '',
  value,
  height,
  label,
  error,
  isRequired,
  setInputRef,
}) => {
  const textAreaId = label ? `${snakeCase(label)}-textarea` : undefined

  const style = omitBy(
    {
      height: height && `${height}px`,
    },
    item => !item,
  )

  return (
    <div className={classNames(className)} data-test-id={dataTestId}>
      {label && (
        <label htmlFor={textAreaId} className={styles.textareaLabel}>
          <Label isRequired={isRequired}>
            <Text color="greyBlue">{label}</Text>
          </Label>
        </label>
      )}

      <textarea
        id={textAreaId}
        style={style}
        className={classNames(styles.textarea, { [styles.fieldError]: !!error })}
        disabled={isDisabled}
        maxLength={maxLength}
        onChange={event => onChange(event.target.value)}
        placeholder={placeholder}
        value={value}
        ref={setInputRef}
      />

      {error && <div className={styles.error}>{error}</div>}
    </div>
  )
}

Textarea.propTypes = {
  className: PropTypes.string,
  dataTestId: PropTypes.string,
  isDisabled: PropTypes.bool,
  maxLength: PropTypes.number,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  value: PropTypes.any,
  height: PropTypes.number,
  label: PropTypes.string,
  error: PropTypes.string,
  isRequired: PropTypes.bool,
  setInputRef: PropTypes.func,
}
